import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shorts from "@/pages/Shorts";
import Watch from "@/pages/Watch";
import Auth from "@/pages/Auth";
import Upload from "@/pages/Upload";
import Coins from "@/pages/Coins";
import Profile from "@/pages/Profile";
import Search from "@/pages/Search";
import Admin from "@/pages/Admin";
import Notifications from "@/pages/Notifications";
import Playlists from "@/pages/Playlists";
import PlaylistPlayer from "@/pages/PlaylistPlayer";
import Membership from "@/pages/Membership";
import Category from "@/pages/Category";
import Downloads from "@/pages/Downloads";
import Legal from "@/pages/Legal";
import Copyright from "@/pages/Copyright";
import TV from "@/pages/TV";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Auth mode="login"/>}/>
          <Route path="/register" element={<Auth mode="register"/>}/>
          <Route path="/tv" element={<TV/>}/>
          <Route path="/*" element={<Layout><Inner/></Layout>}/>
        </Routes>
        <Toaster theme="dark" position="top-center" richColors/>
      </BrowserRouter>
    </AuthProvider>
  );
}

function Inner() {
  return (
    <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/shorts" element={<Shorts/>}/>
      <Route path="/watch/:id" element={<Watch/>}/>
      <Route path="/upload" element={<Upload/>}/>
      <Route path="/coins" element={<Coins/>}/>
      <Route path="/profile" element={<Profile/>}/>
      <Route path="/u/:uid" element={<Profile/>}/>
      <Route path="/search" element={<Search/>}/>
      <Route path="/admin" element={<Admin/>}/>
      <Route path="/notifications" element={<Notifications/>}/>
      <Route path="/playlists" element={<Playlists/>}/>
      <Route path="/playlists/:pid" element={<PlaylistPlayer/>}/>
      <Route path="/membership" element={<Membership/>}/>
      <Route path="/category/:name" element={<Category/>}/>
      <Route path="/downloads" element={<Downloads/>}/>
      <Route path="/terms" element={<Legal doc="terms"/>}/>
      <Route path="/privacy" element={<Legal doc="privacy"/>}/>
      <Route path="/dmca" element={<Legal doc="dmca"/>}/>
      <Route path="/copyright" element={<Copyright/>}/>
    </Routes>
  );
}

export default App;
